import request from '@/utils/seftRequest';

// 延长临时套餐有效期
export function renewCausalPlanBsnl(data) {
  return request('/ding/subsService/renewCausalPlanBsnl', {
    method: 'POST',
    body: data,
  });
}
